import React, { useState } from "react";
import { makeStyles } from "@material-ui/core/styles";
import { useDispatch } from "react-redux";
import { Button, Dialog, DialogTitle, Grid, Toolbar, Typography } from "@material-ui/core";
import SaveIcon from "@material-ui/icons/Save";
import CancelIcon from '@material-ui/icons/Cancel';
import { MuiPickersUtilsProvider, KeyboardDatePicker } from '@material-ui/pickers';
import { ValidatorForm, TextValidator } from "react-material-ui-form-validator";
import DateFnsUtils from "@date-io/date-fns";
import esLocale from "date-fns/locale/es";
import { CboTipoFeriados } from "../../../cbos/CboTipoFeriados";
import { agregarEditarFeriado } from "../../../../actions/turnos/feriados";
import { AlertFinalizadoStepper } from "../../../stepper/AlertFinalizadoStepper";
import { armarParametros } from "../../../../helpers/parametros";
import { fetchConToken } from "../../../../helpers/fetch";
import { startAlerta } from "../../../../actions/ui/alertas";
import { finishSpinner, startSpinner } from "../../../../actions/ui/spinner";
import { TIPO_FERIADO } from "../../../../utils/constants";

const useStyles = makeStyles((theme) => ({
    root:{
        marginLeft: "auto",
        marginRight: "auto",
        width: "74%",
    },
    header:{
        background: '#68389F',
        color:'white'
      },
    botonera: {
        marginTop: 50,
        marginLeft: 55,
        marginBottom: 20,
        paddingBottom: 13
    },
}));

const initialState = {
    fecha: new Date(),
    idTipo:'',
    descripcion:'',
    idFeriado: 0,
  }

export const ModalAltaFeriado = (props) => {
    const classes = useStyles();
    const dispatch = useDispatch();
    const { open, setOpen, title } = props;
    const [ turnosTomados, setTurnosTomados ] = useState(0);
    const [ openQuestion, setOpenQuestion ] = useState(false);
    const [ openQuestionTurnos, setOpenQuestionTurnos ] = useState(false);
    const [ feriadoNuevo, setFeriadoNuevo ] = useState({ ...initialState });

    const handleVerificarTurnos = () => {
        const verificarTurnosTomados = async () => {
            setTurnosTomados(0);
            setOpenQuestion(false);
            try{
                dispatch(startSpinner());
                const parametros = armarParametros(null, null, null, null, null, feriadoNuevo.fecha.toISOString(), null, null, null, null, null, null, null, null, null, true);
                const response = await fetchConToken(`Agenda/traerPorFecha?${parametros}`);
                const contentType = response.headers.get("content-type");
                if (contentType && contentType.indexOf("application/json") !== -1) {
                    const lista = await response.json();
                    if (response.status !== 200) throw lista.errores;
                    if(lista.length > 0){                       //Valido si tiene turnos tomados para esa fecha
                        setTurnosTomados(lista);
                        setOpenQuestionTurnos(true);
                    }else{
                        handleSave();
                    }
                }
                dispatch(finishSpinner());
            } catch (err){
                dispatch(finishSpinner());
                dispatch(startAlerta(err, "warning", `¡Error!`));
            }
        };
        if(feriadoNuevo.idTipo === TIPO_FERIADO.FERIADO_NACIONAL)
            verificarTurnosTomados();
        else
            handleSave();
    }

    const handleSave = () => {
        dispatch( agregarEditarFeriado(feriadoNuevo.fecha, feriadoNuevo.idTipo, feriadoNuevo.descripcion, feriadoNuevo.idFeriado, closeModal) );
        setOpenQuestionTurnos(false);
    }

    const closeModal = () => {
        setOpen(false);
        setOpenQuestion(false);
        setFeriadoNuevo({ ...initialState });
    }
    
    const handleInputChange = (e) => {
        setFeriadoNuevo({...feriadoNuevo, [e.target.name]:e.target.value});
    }
    
    return (
        <Dialog
            maxWidth="md"
            fullWidth={true}
            open={open}
            onClose={closeModal}
        >
            <DialogTitle className={classes.header}>
                <Toolbar >
                    <Typography variant="h6" >
                        {title}
                    </Typography>
                </Toolbar>
            </DialogTitle>
            <ValidatorForm onSubmit={() => setOpenQuestion(true)}>
                <div className={classes.root}>
                    <Grid container >
                        <Grid item xs={12} md={4} style={{marginRight: 35}} >
                            <MuiPickersUtilsProvider locale={esLocale} utils={DateFnsUtils}>
                                <KeyboardDatePicker
                                    margin="normal"
                                    id="date-picker-dialog"
                                    label="Fecha"
                                    format="dd/MM/yyyy"
                                    minDate={new Date()}
                                    value={feriadoNuevo.fecha}
                                    onChange={(e) => handleInputChange({target: {name: 'fecha', value: e}})}
                                    KeyboardButtonProps={{
                                        'aria-label': 'change date',
                                    }}
                                />
                            </MuiPickersUtilsProvider>
                        </Grid>
                        <Grid item xs={12} md={4} >
                            <CboTipoFeriados
                                manejadorInputChange={handleInputChange}
                                valor={feriadoNuevo.idTipo}
                                name={'idTipo'}
                            />
                        </Grid>
                        <Grid item xs={4} >
                        </Grid>
                    </Grid>
                    <Grid container >
                        <Grid item xs={12} >
                            <TextValidator
                                fullWidth
                                margin="normal"
                                label="Descripcion"
                                name="descripcion"
                                value={feriadoNuevo.descripcion}
                                autoComplete="off"
                                onChange={handleInputChange}
                                validators={["required"]}
                                errorMessages={["Este campo es obligatorio"]}
                            />
                        </Grid>
                    </Grid>
                        
                    <Grid className={classes.botonera} container >
                        <Grid item xs={10}>
                            <Grid
                                container
                                direction="row"
                                justify="space-between"
                                alignItems="center"
                            >
                                <Button
                                    variant="contained"
                                    color="secondary"
                                    size="small"
                                    startIcon={<CancelIcon />}
                                    onClick={closeModal}
                                >
                                    CANCELAR
                                </Button>
                                <Button
                                    variant="contained"
                                    color="primary"
                                    size="small"
                                    startIcon={<SaveIcon />}
                                    type="submit"
                                >
                                    GUARDAR
                                </Button>
                            </Grid>
                        </Grid>
                    </Grid>
                    {openQuestion && 
                        <AlertFinalizadoStepper
                            open={openQuestion}
                            pregunta={"Alta de Nuevo Feriado"}
                            dialogText={"Se va a configurar un nuevo feriado, esto generará cambios en agendas de prestadores, está seguro?"}
                            buttonCancel={"Cancelar"}
                            buttonSubmit={"Continuar"}
                            handleClose={() => setOpenQuestion(false)}
                            handleSend={handleVerificarTurnos}
                        />
                    }
                    {openQuestionTurnos && 
                        <AlertFinalizadoStepper
                            open={openQuestionTurnos}
                            pregunta={`Turnos tomados`}
                            dialogText={`Se van a cancelar ${turnosTomados.length} turnos tomados esta seguro?`}
                            buttonCancel={"Cancelar"}
                            buttonSubmit={"Continuar"}
                            handleClose={() => setOpenQuestionTurnos(false)}
                            handleSend={handleSave}
                        />
                    }  
                </div>
            </ValidatorForm>
        </Dialog>
    );

};
